import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './TableHeading.module.scss';

type Props = {
  tableTitle?: string;
  tableType: string;
  tableTypeClassName?: string;
  tableTitleClassName?: string;
};

const TableHeading: FC<Props> = ({
  tableTitle,
  tableType,
  tableTypeClassName,
  tableTitleClassName
}) => (
  <>
    <div className={classNames(styles['table-type'], tableTypeClassName)}>
      {tableType}
    </div>
    {tableTitle && (
      <div className={classNames(styles['table-title'], tableTitleClassName)}>
        {tableTitle}
      </div>
    )}
  </>
);

export default TableHeading;
